/**
 * globalUI.js — Event bus global para loading/error states
 *
 * Usado pelo App.vue para centralizar exibição de loading e modal de erro.
 * Outros serviços/componentes disparam eventos através de showLoading(),
 * hideLoading() e showError().
 */

const listeners = {
  loading: [],
  error: []
}

function subscribe(list, callback) {
  list.push(callback)
  return () => {
    const idx = list.indexOf(callback)
    if (idx !== -1) list.splice(idx, 1)
  }
}

function emit(list, ...args) {
  list.forEach(fn => fn(...args))
}

/**
 * Inscreve-se para mudanças no estado global de loading.
 * @param {(show: boolean) => void} callback
 * @returns {() => void} unsubscribe function
 */
export function onLoading(callback) {
  return subscribe(listeners.loading, callback)
}

/**
 * Inscreve-se para mudanças no estado global de erro.
 * O data pode conter { message, retry }.
 * Quando chamado com null, limpa o erro.
 * @param {(data: object|null) => void} callback
 * @returns {() => void} unsubscribe function
 */
export function onError(callback) {
  return subscribe(listeners.error, callback)
}

/**
 * Exibe o loading global.
 */
export function showLoading() {
  emit(listeners.loading, true)
}

/**
 * Esconde o loading global.
 */
export function hideLoading() {
  emit(listeners.loading, false)
}

/**
 * Exibe o modal de erro global.
 * @param {{ message?: string, retry?: Function }} data
 */
export function showError(data) {
  emit(listeners.error, data)
}

/**
 * Esconde o modal de erro global.
 */
export function hideError() {
  emit(listeners.error, null)
}

export default {
  onLoading,
  onError,
  showLoading,
  hideLoading,
  showError,
  hideError
}
